import { type ForwardedRef, type RefObject, useEffect, useRef } from "react";

// Make a difference between undefined (not set) and null (waiting for render)
// Need this difference for useHotKeys
/** @deprecated Should not be necessary with React 19 */
export const useForwardedRef = <T = HTMLElement>(ref?: RefObject<T | null> | ForwardedRef<T>): RefObject<T | null> => {
  const innerRef: RefObject<T | null> = useRef<T>(null);

  useEffect(() => {
    if (!ref) return;

    if (typeof ref === "function") {
      ref(innerRef.current);
    } else {
      innerRef.current = ref.current;
    }
  });

  return innerRef;
};
